






// Fixes the iOS bottom navigation bar obscuring
// This is a direct port from https://github.com/mvasin/react-div-100vh
// See the documentation on that page for more.
// Unfortunately instead of using :style on our parent component we need to use :useStyle instead
// as :style is a reserved property name in VueJS. (e.g. <Div100vh :useStyle="{height:'100rvh'}")

import Vue from "vue";
import convertStyle from "./div100vh/convertStyle";
import getWindowHeight from "./div100vh/getWindowHeight";
import { createThrottleListener } from "@/js/util/event/Listeners";

export default Vue.extend({
  props: {
    tag: {
      type: String,
      default: "div"
    },
    useStyle: {
      type: Object
    }
  },
  data() {
    return {
      updatedStyle: {}
    };
  },
  methods: {
    updateStyle() {
      this.updatedStyle = convertStyle(this.useStyle, getWindowHeight());
    }
  },
  mounted() {
    const opts: any = this.$options;
    opts.onResize = createThrottleListener("resize", window);
    opts.disposeResize = opts.onResize(() => this.updateStyle());
    // this.updateStyle();
  },
  beforeDestroy() {
    (this.$options as any).disposeResize();
  }
});
